module.exports = __webpack_public_path__ + "static/media/premium-badge.e06c870d.svg";